import React from 'react';
import ReactDOM from 'react-dom';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import { Provider } from 'react-redux';
import AddressWhispererNette from './AddressWhispererNette';

loadDOMComponent({
	selector: 'react-address-whisperer',
	callback: ({ container, context, props }: any) => {
		const inputName = props?.inputName ?? container.getAttribute('inputName');
		const fieldKey =
			props?.fieldKey ?? container.getAttribute('fieldKey') ?? '';
		const fieldNamesRaw =
			props?.fieldNames ?? container.getAttribute('fieldNames');
		const responseMappingRaw =
			props?.responseMapping ?? container.getAttribute('responseMapping');
		const apiEndpoint =
			props?.apiEndpoint ?? container.getAttribute('apiEndpoint');
		const queryParamName =
			props?.queryParamName ?? container.getAttribute('queryParamName');
		const value = props?.value ?? container.getAttribute('value') ?? '';
		const placeholder =
			props?.placeholder ?? container.getAttribute('placeholder');
		const label = props?.label ?? container.getAttribute('label');
		const disabled =
			container.getAttribute('disabled') === 'true' ||
			container.getAttribute('data-disabled') === 'true';

		const fieldNames =
			typeof fieldNamesRaw === 'string'
				? JSON.parse(fieldNamesRaw)
				: fieldNamesRaw ?? {};
		const responseMapping =
			typeof responseMappingRaw === 'string'
				? JSON.parse(responseMappingRaw)
				: responseMappingRaw ?? {};

		const netteRules = container.getAttribute('data-nette-rules');
		const hasInvalid = container.classList.contains('is-invalid');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AddressWhispererNette
						inputName={inputName}
						fieldKey={fieldKey}
						fieldNames={fieldNames}
						responseMapping={responseMapping}
						apiEndpoint={apiEndpoint}
						queryParamName={queryParamName}
						value={value}
						placeholder={placeholder}
						label={label}
						disabled={disabled}
						netteRules={netteRules}
						hasInvalid={hasInvalid}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
